import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchProductReviews } from 'src/services/rar-data-api/fetchProductReviews';
import type { RarDataAPIResponse } from 'src/services/rar-data-api/types/RarDataAPIResponse';

export interface RequestProductReviewsOptions {
  autoInitiated?: boolean;
  page: number;
  perPage?: number;
  productCode: number;
}

export const requestProductReviews = createAsyncThunk<
  RarDataAPIResponse,
  RequestProductReviewsOptions
>('productReviews/requestProductReviews', async ({ page, perPage, productCode }) => {
  const data = await fetchProductReviews(productCode, { page, perPage });

  return data;
});
